import { inject, Injectable } from '@angular/core';
import { SubscriptionsDataDto } from '../types';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsInfoService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getSubscriptionsStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/subscriptions-data').pipe(
      httpRetry(5),
      tap((res: SubscriptionsDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
